import React from 'react'
import classNames from 'classnames'

import { Radio } from '@/components/forms/Checkbox'
import { FormField } from '@/components/forms/FormField'
import { SCORE_OPTIONS } from '@/utils/promptFeedback.helpers'

export const ScoreForm = ({ baseDataTestId, isDisabled, score, setScore }) => {
  return (
    <div className="field-stack">
      <div className="flex-space-between mt">
        {SCORE_OPTIONS.map(({ score: optionScore, label, value, testId, className }) => (
          <FormField key={value}>
            <Radio
              label={label}
              // Scoped per form: several ScoreForms render at once, and these are real
              // radio inputs now, so a shared name would make them one native group.
              name={`${baseDataTestId}-score`}
              value={value}
              checked={score === optionScore}
              className={classNames('dispute-radio', className)}
              data-testid={`${baseDataTestId}-radio-${testId}`}
              onChange={() => setScore(optionScore)}
              disabled={isDisabled}
            />
          </FormField>
        ))}
      </div>
    </div>
  )
}
